// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"c2bcc6f9","152":"0d76539e","202":"c033879a","239":"10076699","355":"552b77c8","455":"4f93d631","484":"1bb89af0","533":"ccf369bf","717":"311a4fda","733":"90cbd698","815":"8804a3b7","914":"0b21751d","953":"dbe58f46","975":"2f36fcbb","977":"72c4f5c7"}[chunkId] + ".chunk.js";
};